import React, { useState, useEffect, useRef } from "react";
import Layout from "../common/Layout";
import Leftsidebar from "../sidebar/leftsidebar";
import LeftResponsivesidebar from "../sidebar/left-responsive";
import Headmenu from "../sidebar/headmenu";
import axios from "axios";

import {
  BsCameraVideoOffFill,
  BsMicMute,
  BsMicMuteFill,
  BsFillCameraVideoFill,
} from "react-icons/bs";
import { Switch } from "@headlessui/react";
import Webcam from "react-webcam";
import { TbWorld } from "react-icons/tb";
import videoslash from "../../assets/images/icons/video-slash.png";
import cameraoff from "../../assets/images/icons/camera-off.png";
import golivecam from "../../assets/images/icons/golive-cam.png";
import global from "../../assets/images/icons/global.svg";
import profileimg from "../../assets/profile.png";
import like from "../../assets/images/icons/like.png";
import golivebanner from "../../assets/images/golive-prf.png";
import { FaSearch } from "react-icons/fa";
import { io } from "socket.io-client";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const API_ORIGIN = API_BASE_URL.replace(/\/api$/i, "");
const BASE_URL = API_BASE_URL;
const SOCKET_URL = API_ORIGIN;

const Seller = () => {
  const [cameraOn, setCameraOn] = useState(false);
  const [micOn, setMicOn] = useState(false);
  const [commentsEnabled, setCommentsEnabled] = useState(false);
  const webcamRef = useRef(null);

  const [deviceId, setDeviceId] = React.useState({});
  const [devices, setDevices] = React.useState([]);

  const [isLive, setIsLive] = useState(false);
const [streamId, setStreamId] = useState(null);
const [countdown, setCountdown] = useState(0);
const [title, setTitle] = useState(""); // You can use seller name or product name
const [playbackUrl, setPlaybackUrl] = useState("");
const users = JSON.parse(sessionStorage.getItem("user") || localStorage.getItem("user"));
  const [tags, setTags] = useState([]);
  const [category, setCategory] = useState("");
const [startTime, setStartTime] = useState(null);
const profiledata = {
  id: sessionStorage.getItem("userId"), // or from your auth provider
  username: sessionStorage.getItem("username") || "You",
};
const [profilePictureUrl, setProfilePictureUrl] = useState(() => {
    return sessionStorage.getItem("profilePictureUrl") || profileimg; // Default to placeholder image
  });
 const formatDate = (date) => {
  if (!date) return "";
  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}; 
 const storedUser = sessionStorage.getItem("user") || localStorage.getItem("user");
      const user = storedUser ? JSON.parse(storedUser) : null;

  const handleDevices = React.useCallback(
    (mediaDevices) =>
      setDevices(mediaDevices.filter(({ kind }) => kind === "videoinput")),
    [setDevices]
  );

  React.useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then(handleDevices);
  }, [handleDevices]);

  console.log(webcamRef);
  console.log(deviceId);


  const [chatMessages, setChatMessages] = useState([]);

  const liveChatMessages = [
    {
      id: 1,
      name: "Ralph Edwards",
      time: "12:20 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 2,
      name: "Ralph Edwards",
      time: "12:21 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 3,
      name: "Ralph Edwards",
      time: "12:22 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 4,
      name: "Ralph Edwards",
      time: "12:20 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 5,
      name: "Ralph Edwards",
      time: "12:21 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 6,
      name: "Ralph Edwards",
      time: "12:22 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 7,
      name: "Ralph Edwards",
      time: "12:20 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 8,
      name: "Ralph Edwards",
      time: "12:21 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 9,
      name: "Ralph Edwards",
      time: "12:22 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
  ];

  const [products, setProducts] = useState([]);
const [liveProducts, setLiveProducts] = useState([]);

const handleStartSelling = async (product) => {
  try {
    const sellerId = String(product.seller_id); // correct seller
    const streamId = sessionStorage.getItem("streamId");

    if (!streamId) {
      alert("You must go live first before adding products!");
      return;
    }

    const res = await axios.post(
      `${API_BASE_URL}/live/${streamId}/products`,
      {
        sellerId: sellerId,
        products: [String(product.id)], // backend requires strings
      },
      {
        headers: {
          token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
          "Content-Type": "application/json",
        },
      }
    );

    if (res.data.status === "success") {
      const attachedIds = res.data.attachedProducts || [];

      // ✅ find products from your existing list that match those IDs
      const addedProducts = products.filter((p) =>
        attachedIds.includes(String(p.id))
      );

      // ✅ convert to your UI format
      const mappedProducts = addedProducts.map((p) => ({
        id: p.id,
        name: p.product_name,
        originalPrice: p.product_price,
        discountedPrice: p.discount_price,
        offer: p.offer_percentage,
        qtyOutOf: p.product_qty,
        qtySold: 0,
        countdown: "00:00",
        image: p?.product_media?.[0]?.url || "/image/default.png",
      }));

      // ✅ merge into liveProducts (avoid duplicates)
      setLiveProducts((prev) => {
        const existingIds = prev.map((lp) => lp.id);
        const newOnes = mappedProducts.filter(
          (mp) => !existingIds.includes(mp.id)
        );
        return [...prev, ...newOnes];
      });

      console.log("✅ Added products to live stream:", mappedProducts);
    } else {
      console.error("❌ Failed to add product:", res.data);
      alert(res.data.message || "Failed to start selling");
    }
  } catch (err) {
    console.error("🔥 Error in handleStartSelling:", err);
    alert(err.response?.data?.message || "Something went wrong!");
  }
};

const handleStopSelling = async (productId) => {
  try {
    const streamId = sessionStorage.getItem("streamId");

    if (!streamId) {
      alert("No active stream found. Please go live first.");
      return;
    }

    // 🔴 Call the DELETE API
    const res = await axios.delete(
      `${API_BASE_URL}/live/${streamId}/products/${productId}`,
      {
        headers: {
          token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
          "Content-Type": "application/json",
        },
        data: {
          streamId: streamId,
          productId: productId,
        },
      }
    );

    if (res.data.status === "success") {
      console.log("✅ Product removed from live:", productId);

      // 🧹 Remove product from UI
      setLiveProducts((prev) => prev.filter((p) => p.id !== productId));
    } else {
      console.error("❌ Failed to remove product:", res.data);
      alert(res.data.message || "Failed to stop selling this product");
    }
  } catch (err) {
    console.error("🔥 Error in handleStopSelling:", err);
    alert(err.response?.data?.message || "Something went wrong!");
  }
};

  const fetchProducts = async (search = "") => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/product/get-products`,
      {
        filters: { ...(search ? { search } : {}) },
        page: 1,
        limit: 1000,
      },
      {
        headers: {
          token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
          "Content-Type": "application/json",
        },
      }
    );

    if (res.data.success) {
      setProducts(res.data.result.products || []);
    } else {
      setProducts([]);
    }
  } catch (err) {
    console.error("Error fetching products:", err);
    setProducts([]);
  }
};

  useEffect(() => {
  fetchProducts();
}, []);
  // const comments = [
  //   {
  //     id: 1,
  //     name: "Ralph Edwards",
  //     time: "12:30 PM",
  //     message:
  //       "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.",
  //     avatar: "/image/profilepic.png",
  //   },
  //   {
  //     id: 2,
  //     name: "Ralph Edwards",
  //     time: "12:30 PM",
  //     message:
  //       "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.",
  //     avatar: "/image/profilepic.png",
  //   },
  // ];

  // const products = [
  //   {
  //     id: 1,
  //     image: "https://via.placeholder.com/224x391", // replace with actual product image url
  //     name: "ADIDAS 4DFWD X PARLEY RUNNING SHOES",
  //     originalPrice: 444,
  //     discountedPrice: 333.2,
  //     qtySold: 10,
  //     qtyOutOf: 25,
  //     countdown: "01:00:00",
  //   },
  //   {
  //     id: 1,
  //     image: "https://via.placeholder.com/224x391", // replace with actual product image url
  //     name: "ADIDAS 4DFWD X PARLEY RUNNING SHOES",
  //     originalPrice: 444,
  //     discountedPrice: 333.2,
  //     qtySold: 10,
  //     qtyOutOf: 25,
  //     countdown: "01:00:00",
  //   },
  // ];


  useEffect(() => {
  const s = io(SOCKET_URL, { transports: ["websocket"] });
  s.on("connect", () => console.log("✅ Seller socket connected:", s.id));
  setSocket(s);

  return () => {
    s.disconnect();
  };
}, []);

const videoRef = useRef(null);

const [cameraStream, setCameraStream] = useState(null);
const [cameraError, setCameraError] = useState(false);


// START CAMERA
const startCamera = async () => {
  setCameraError(false);

  try {
    // navigator.permissions.query may not be supported in all browsers - wrap it
    try {
      const perm = await navigator.permissions.query?.({ name: "camera" });
      if (perm && perm.state === "denied") {
        alert(
          "Camera access is blocked. Click the lock icon next to the URL and allow Camera, then refresh."
        );
        return;
      }
    } catch (permErr) {
      // ignore permission API errors and continue to request getUserMedia
      console.debug("Permissions API not available or failed:", permErr);
    }

    // Request camera + mic (you can set audio:false if you want preview without mic)
    const stream = await navigator.mediaDevices.getUserMedia({
      video: { width: 1280, height: 720, facingMode: "user" },
      audio: true,
    });

    // Save stream to state (we attach to the video element in useEffect below)
    setCameraStream(stream);
    setChatMessages(liveChatMessages);

    // debug
    console.log("✅ getUserMedia success, tracks:", stream.getTracks());
  } catch (err) {
    console.error("Error accessing camera/microphone:", err);
    setCameraError(true);
  }
};

// ATTACH STREAM TO VIDEO AFTER RERENDER
useEffect(() => {
  let tryPlayTimeout = null;

  const attach = async () => {
    if (!cameraStream || !videoRef.current) return;

    try {
      videoRef.current.srcObject = cameraStream;
      videoRef.current.muted = true; // required for autoplay in many browsers (preview)
      // ensure playsInline and autoplay attributes are present on the element (see JSX below)
      const playPromise = videoRef.current.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch((err) => {
          // autoplay might be blocked; try again shortly
          console.warn("video.play() was rejected:", err);
          // small retry after a short delay
          tryPlayTimeout = setTimeout(() => {
            videoRef.current?.play().catch((e) => console.warn("retry play failed", e));
          }, 200);
        });
      }
    } catch (err) {
      console.error("Attach stream error:", err);
    }
  };

  attach();

  return () => {
    if (tryPlayTimeout) clearTimeout(tryPlayTimeout);
  };
}, [cameraStream]);

// STOP CAMERA
const stopCamera = () => {
  try {
    // stop media tracks stored in state
    if (cameraStream) {
      cameraStream.getTracks().forEach((t) => {
        try { t.stop(); } catch (e) { /* ignore */ }
      });
      setCameraStream(null);
    }

    // also pause and clear the video element
    if (videoRef.current) {
      try {
        videoRef.current.pause();
      } catch (e) {}
      try {
        videoRef.current.srcObject = null;
      } catch (e) {}
    }
    setChatMessages([]);
    // do NOT change isLive here if you manage it from handleGoLive
  } catch (err) {
    console.error("stopCamera error:", err);
  }
};

// CLEANUP ON UNMOUNT (important)
useEffect(() => {
  return () => {
    if (cameraStream) {
      cameraStream.getTracks().forEach((t) => {
        try { t.stop(); } catch (e) {}
      });
    }
  };
}, []); // run only on unmount


  const getAuthHeaders = () => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) {
      throw new Error("Authentication token is missing. Please log in again.");
    }
    return {
      "Content-Type": "application/json",
      token, // ✅ send as header
    };
  };

  // 1️⃣ Initialize Live Stream
  const initLiveStream = async () => {
    try {
      const res = await fetch(`${BASE_URL}/live/init`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({ recording_enabled: false }),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        const { stream_id } = data.result;
        // ✅ Pass stream_id directly instead of waiting for state
        await saveMetadata(stream_id);
        console.log("Stream initialized:", data.result);
      } else {
        console.error("Init Stream failed:", data.message);
      }
    } catch (err) {
      console.error("Init Stream Error:", err);
    }
  };

  // 2️⃣ Save Metadata
  const saveMetadata = async (id) => {
    const sid = id || streamId; // ✅ Prefer passed id, fallback to state
    if (!sid) return;
    try {
      const res = await fetch(`${BASE_URL}/live/metadata`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({
          stream_id: sid,
          title,
          category,
          tags,
        }),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        console.log("Metadata saved:", data.result);
        await setPreview(sid); // ✅ Chain next step with sid
      } else {
        console.error("Metadata failed:", data.message);
      }
    } catch (err) {
      console.error("Metadata Error:", err);
    }
  };

  // 3️⃣ Set Preview
  const setPreview = async (id) => {
    const sid = id || streamId;
    if (!sid) return;
    try {
      await fetch(`${BASE_URL}/live/preview`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({ stream_id: sid }),
      });
      console.log("Stream is in preview mode");
    } catch (err) {
      console.error("Preview Error:", err);
    }
  };

  // 4️⃣ Start Live
  const startLive = async (id) => {
    const sid = id || streamId;
    if (!sid) return;
    try {
      await fetch(`${BASE_URL}/live/start`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({ stream_id: sid }),
      });
      console.log("Stream started");
    } catch (err) {
      console.error("Start Live Error:", err);
    }
  };

  // 5️⃣ End Live
  const endLive = async (id) => {
    const sid = id || streamId;
    if (!sid) return;
    try {
      await fetch(`${BASE_URL}/live/end`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({ stream_id: sid }),
      });
      console.log("Stream ended");
      window.location.reload(); // simple way to reset state/UI
  } catch (err) {
      console.error("End Live Error:", err);
    }
  };


 const handleGoLive = async () => {
    if (isLive) {
      // 🔴 Stop flow
      await endLive();
      stopCamera();
      setIsLive(false);
      setCountdown(0);
    } else {
      // 🟢 Start flow
      // if (!title.trim() || !category.trim()) {
      //   alert("Please fill in Title and Category before going live.");
      //   return;
      // }
      // if (!title.trim()) {
      //   alert("Please enter a Title before going live.");
      //   return;
      // }

      try {
        // 1️⃣ Init
        const res = await fetch(`${BASE_URL}/live/init`, {
          method: "POST",
          headers: getAuthHeaders(),
          body: JSON.stringify({ recording_enabled: false }),
        });
        const data = await res.json();
        if (!res.ok || !data.success) throw new Error(data.message);
        const sid = data.result.stream_id;
        setStreamId(sid);


        
      // ✅ Store streamId + sellerId in sessionStorage
      const sellerId = user?.seller_id || user?.id || null; // adjust depending on your user object
      if (sellerId) sessionStorage.setItem("sellerId", sellerId.toString());
      sessionStorage.setItem("streamId", sid);
      localStorage.setItem("streamId", sid);

      console.log("🟢 Stream started:", sid, "Seller:", sellerId);

        // 2️⃣ Metadata
        await fetch(`${BASE_URL}/live/metadata`, {
          method: "POST",
          headers: getAuthHeaders(),
          body: JSON.stringify({
            stream_id: sid,
            title,
            category: "General", // ✅ hardcoded
            tags: ["live", "stream"], // ✅ hardcoded
          }),
        });

        // 3️⃣ Preview
        await fetch(`${BASE_URL}/live/preview`, {
          method: "POST",
          headers: getAuthHeaders(),
          body: JSON.stringify({ stream_id: sid }),
        });

        // 🎬 Show 3-second countdown
        setCountdown(3);
        let timer = 3;
        const interval = setInterval(() => {
          timer -= 1;
          setCountdown(timer);
          if (timer === 0) {
            clearInterval(interval);
            // ✅ Save start time here
            setStartTime(new Date());
            // 4️⃣ Start live after countdown
            startCamera();
            startLive(sid);
            setIsLive(true);
            setCountdown(0);
          }
        }, 1000);
      } catch (err) {
        console.error("Go Live Error:", err);
        alert(err.message);
      }
    }
  };
const [comments, setComments] = useState([]);   // store all comments
const [comment, setComment] = useState("");     // input field value
const [socket, setSocket] = useState(null);
const [viewerCount, setViewerCount] = useState(0);
const [streamStatus, setStreamStatus] = useState("idle");

const deleteComment = async (commentId) => {
  if (!streamId || !commentId) return;

  try {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) {
      alert("Authentication required");
      return;
    }

    const res = await fetch(
      `${BASE_URL}/streams/${streamId}/comments/${commentId}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          token,
        },
        body: JSON.stringify({
          stream_id: streamId,
          comment_id: commentId,
        }),
      }
    );

    const data = await res.json();

    if (res.ok && data.success) {
      console.log("✅ Comment deleted:", data.result);
      // Remove from UI
      setComments((prev) =>
        prev.filter((c) => c.commentId !== commentId)
      );
    } else {
      console.error("❌ Delete comment failed:", data.message);
    }
  } catch (err) {
    console.error("Delete Comment Error:", err);
  }
};

const fetchComments = async () => {
  if (!streamId) return;

  try {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) {
      alert("Authentication required");
      return;
    }

    const res = await fetch(`${BASE_URL}/streams/${streamId}/comments?limit=50`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });

    const data = await res.json();

    if (res.ok && data.success) {
      console.log("✅ Comments fetched:", data.result.comments);

      // store the array of comments
      setComments(Array.isArray(data.result.comments) ? data.result.comments : []);
    } else {
      console.error("❌ Fetch comments failed:", data.message);
    }
  } catch (err) {
    console.error("Fetch Comments Error:", err);
  }
};


// ✅ Function to post comment
const postComment = async () => {
  if (!comment.trim() || !streamId) return;

  try {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) {
      alert("Authentication required");
      return;
    }

    const res = await fetch(`${BASE_URL}/streams/${streamId}/comments`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token,
      },
      body: JSON.stringify({
        comment: comment,
        timestamp: new Date().toISOString(),
      }),
    });
      

    const data = await res.json();

    if (res.ok && data.success) {
      console.log("✅ Comment added:", data.result);
      setComment(""); 
setComments((prev) => [
    ...prev,
    {
      commentId: data.result.commentId,
      userId: users.id,
      username: users.username,
      profile_picture_url: users.profile_picture_url,
      comment,
      timestamp: new Date().toISOString(),
    }
  ]);
      // fetch updated comments OR just append new one
      fetchComments();
      // or:
      // setComments((prev) => [...prev, { comment, timestamp: new Date().toISOString(), commentId: data.result.commentId }]);
    } else {
      console.error("❌ Comment failed:", data.message);
    }
  } catch (err) {
    console.error("Comment API Error:", err);
  }
};
useEffect(() => {
  if (streamId) {
    fetchComments();
  }
}, [streamId]);

useEffect(() => {
  if (!streamId) return;

  // ✅ Connect socket
  const s = io(SOCKET_URL, {
    transports: ["websocket"],
    auth: {
      token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"), // send token if required
    },
  });

  setSocket(s);

  // ✅ Join stream comments room
  s.emit("join-stream-comments", {
    streamId,
    userId: profiledata?.id, // your logged in user ID
  });

  // ✅ Handle recent comments (on joining)
  s.on("recent-comments", (data) => {
    console.log("Recent comments:", data);
    setComments(data.comments || []);
  });

  // ✅ Handle new comment
  s.on("new-comment", (data) => {
    console.log("New comment:", data);
    setComments((prev) => [...prev, data]);
  });

  // ✅ Handle deleted comment
  s.on("comment-deleted", (data) => {
    console.log("Comment deleted:", data);
    setComments((prev) => prev.filter((c) => c.commentId !== data.commentId));
  });

  // ✅ Cleanup when leaving
  return () => {
    s.emit("leave-stream-comments", {
      streamId,
      userId: profiledata?.id,
    });
    s.disconnect();
  };
}, [streamId, profiledata?.id]);

useEffect(() => {
  if (!streamId) return;

  const s = io(SOCKET_URL, {
    transports: ["websocket"],
    auth: {
      token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
    },
  });

  setSocket(s);

  // ✅ Join stream room
  s.emit("join-stream", {
    streamId,
    userId: users.id,
  });

  // ✅ Listeners
  s.on("viewer-count-updated", (data) => {
    console.log("Viewer count updated:", data);
    setViewerCount(data.viewerCount);
  });

  s.on("new-viewer", (data) => {
    console.log("New viewer joined:", data);
  });

  s.on("viewer-left", (data) => {
    console.log("Viewer left:", data);
  });

  s.on("stream-initiated", (data) => {
    console.log("Stream initiated:", data);
    setStreamStatus("initiated");
  });

  s.on("stream-preview", (data) => {
    console.log("Stream in preview mode:", data);
    setStreamStatus("preview");
  });

  s.on("stream-started", (data) => {
    console.log("Stream started:", data);
    setStreamStatus("started");
  });

  s.on("stream-went-live", (data) => {
    console.log("Stream went live:", data);
    setStreamStatus("live");
  });

  s.on("stream-ended", (data) => {
    console.log("Stream ended:", data);
    setStreamStatus("ended");
  });

  s.on("stream-room-closed", (data) => {
    console.log("Stream room closed:", data);
    setStreamStatus("closed");
  });

  // ✅ Cleanup
  return () => {
    if (s) {
      s.emit("leave-stream", {
        streamId,
        userId: users.id,
      });
      s.disconnect();
    }
  };
}, [streamId, users?.id]);
if (socket) {
  socket.emit("join-stream", {
    streamId,
    userId: users.id,
  });
}
if (socket) {
  socket.emit("leave-stream", {
    streamId,
    userId: users.id,
  });
}



  return (
    <div className="dashboard w-full min-h-screen flex">
      <Leftsidebar />

      <main className="flex-1 bg-gray-100 p-6">
        <LeftResponsivesidebar />
        <Headmenu />

        <div className="mt-6 w-full  flex gap-4">
          <div className="bg-[#EBF8ED] w-[70%]">
            <div className="w-[100%] flex">
              <div
                className={`bg-black relative rounded-lg h-[400px] flex flex-col justify-center items-center text-white ${
                  commentsEnabled ? "w-[100%]" : "w-[100%]"
                }`}
              >
           {cameraStream ? (
                 <div className="bg-black text-white flex flex-col items-center justify-center camera relative h-[500px]">
                   {cameraStream ? (
                     <div className="">
                       <div className="absolute top-9 left-0 bg-[#ffffff73] profile-img">
                         <div className="flex p-2 pl-5 items-center">
                           {/* Profile Image Inside Textarea */}
                           <div className="profile-dashboard feed-profile-dashboard overflow-hidden">
                             <img
                               src={profilePictureUrl}
                               alt="Profile"
                               className="w-full h-full object-cover"
                             />
                           </div>
                           <div className="feed-title pl-4">
                             <p className="font-semibold text-[#000]">
 {user?.first_name}  {user?.last_name} 
                           </p>
                             <p className="flex text-sm text-[#000]">
     {startTime && formatDate(startTime)}
                             </p>
                           </div>
                         </div>
                       </div>
 {countdown > 0 && (
   <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-70 text-white text-4xl font-bold z-50">
     Going live in {countdown}...
   </div>
 )}
 
 <video
   ref={videoRef}
   autoPlay
   playsInline
   muted
   style={{ width: "100%", height: "100%", backgroundColor: "black" }}
   className="w-full h-full object-cover"
 />
 
 <div className="absolute top-3 left-3 bg-black bg-opacity-50 text-white px-3 py-1 rounded-md">
   Status: {streamStatus}
 </div>
                       {/* Show Like Button only when live */}
                       {isLive && (
                         <button className=" text-white px-5 mx-2 py-1 rounded-[20px] absolute left-3 bottom-5">
     👀 {viewerCount} Viewers
                         </button>
                       )}
                       {/* Show Like Button only when live */}
                       {isLive && (
                         <button className="bg-[#BE1F2E] text-white px-5 mx-2 py-1 rounded-[20px] absolute right-3 bottom-5">
                           LIVE
                         </button>
                       )}
                     </div>
                   ) : cameraError ? (
                     <>
                       <div className="absolute top-9 left-0 bg-[#ffffff73] profile-img">
                         <div className="flex p-2 pl-5 items-center">
                           {/* Profile Image Inside Textarea */}
                           <div className="profile-dashboard feed-profile-dashboard overflow-hidden">
                             <img
                               src={profilePictureUrl}
                               alt="Profile"
                               className="w-full h-full object-cover"
                             />
                           </div>
                           <div className="feed-title pl-4">
                             <p className="font-semibold text-[#000]">
 {user?.first_name}  {user?.last_name} 
                   </p>
                             
                             <p className="flex text-sm text-[#000]">
     {startTime && formatDate(startTime)}
                             </p>
                           </div>
                         </div>
                       </div>
                       <img src={golivecam} alt="Go Live Camera" />
                       <p className="text-lg font-semibold">
                         Allow Access To Camera
                       </p>
                       <p className="text-sm text-gray-400 px-8 text-center">
                         Your Browser Is Not Allowing Live Producer Access To
                         Your Camera. Go To Your Browser Settings And Allow
                         Camera Permission.
                       </p>
                       <button
                         className="mt-4 px-6 py-2 bg-[#D9D9D9] text-[#000000] font-semibold rounded-xl"
                         onClick={startCamera} // ✅ Calls updated function
                       >
                         Retry
                       </button>
                     </>
                   ) : (
                     <>
                       <div
                         className="relative bg-cover bg-center h-[500px] w-full camera text-center"
                         style={{ backgroundImage: `url(${golivebanner})` }} // ✅ Dynamic Banner Image
                       >
                         <div className="absolute top-9 left-0 bg-[#ffffff73] profile-img">
                           <div className="flex p-2 pl-5 items-center">
                             {/* Profile Image Inside Textarea */}
                             <div className="profile-dashboard feed-profile-dashboard overflow-hidden">
                               <img
                                 src={profilePictureUrl}
                                 alt="Profile"
                                 className="w-full h-full object-cover"
                               />
                             </div>
                             <div className="feed-title pl-4">
                               <p className="font-semibold text-[#000]">
 {user?.first_name}  {user?.last_name} 
          </p>
                               <p className="flex text-sm text-[#000]">
     {startTime && formatDate(startTime)}
                               </p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </>
                   )}
                 </div>
) : (
  <div className="flex flex-col justify-center items-center text-white relative bg-black h-[400px] rounded-md">
    <div className="absolute top-0 left-0 px-5 bg-[#D9D9D980] py-2 rounded-br-3xl">
      <div className="flex gap-3 py-2">
        <div className="bg-white p-2 w-[50px] h-[50px] rounded-full">
          <img
            src="/image/wanchain.png"
            alt="logo"
            className="w-[40px] h-[40px] object-contain"
          />
        </div>
        <div className="text-black">
          <p className="font-semibold text-xl">SKY Products</p>
          <p className="text-md">{new Date().toLocaleString()}</p>
        </div>
      </div>
    </div>

    <div className="text-4xl mb-4">
      <BsCameraVideoOffFill />
    </div>

    <p className="text-lg font-semibold">Allow Access To Camera</p>
    <p className="text-sm text-gray-400 text-center max-w-md mt-2">
      Please allow access to your camera to start your live stream.
    </p>

    <button
      onClick={startCamera}
      className="mt-4 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md"
    >
      Allow Camera
    </button>
  </div>
)}


                
              </div>
            </div>

            <div className="mt-4 flex justify-between items-center  p-4 rounded ">
              <div className="flex gap-4 items-center ">
                <button
                  onClick={() => {
                    setCameraOn((prev) => !prev);

                    // OPTIONAL: stop the stream when turning off
                    const videoEl = webcamRef.current?.video;
                    if (videoEl && videoEl.srcObject) {
                      const stream = videoEl.srcObject;
                      const tracks = stream.getTracks();
                      tracks.forEach((track) => track.stop());
                    }
                  }}
                  className="text-xl bg-white rounded-full p-3"
                >
                  {cameraOn ? (
                    <BsFillCameraVideoFill className="text-gray-400" />
                  ) : (
                    <BsCameraVideoOffFill className="text-gray-400" />
                  )}
                </button>
                <button
                  onClick={() => setMicOn(!micOn)}
                  className="text-xl bg-white rounded-full p-3"
                >
                  {micOn ? <BsMicMuteFill /> : <BsMicMute />}
                </button>
                <div className="flex items-center gap-2">
                  <Switch
                    checked={commentsEnabled}
                    onChange={setCommentsEnabled}
                    className={`${
                      commentsEnabled ? "bg-green-800" : "bg-gray-300"
                    } relative inline-flex h-6 w-11 items-center rounded-full`}
                  >
                    <span
                      className={`${
                        commentsEnabled ? "translate-x-6" : "translate-x-1"
                      } inline-block h-4 w-4 transform bg-white rounded-full transition`}
                    />
                  </Switch>
                  <span className="text-sm">Comments</span>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <div className="flex items-center">
                  <TbWorld className="text-xl " />
                  <select className="p-1  rounded bg-transparent text-sm">
                    <option value="Public">Public</option>
                    <option value="Private">Private</option>
                  </select>
                </div>

                {cameraOn ? (
                  <button
                    onClick={() => {
                      setCameraOn((prev) => !prev);

                      // OPTIONAL: stop the stream when turning off
                      const videoEl = webcamRef.current?.video;
                      if (videoEl && videoEl.srcObject) {
                        const stream = videoEl.srcObject;
                        const tracks = stream.getTracks();
                        tracks.forEach((track) => track.stop());
                      }
                    }}
                    className="bg-red-800 text-white px-6 py-2 rounded-full"
                  >
                    Stop
                  </button>
                ) : (
                <button
  onClick={handleGoLive}
  className={`${
    isLive
      ? "bg-red-800 text-white"
      : "bg-gradient-to-r from-green-400 to-blue-500 text-white"
  } px-8 py-2 rounded-full`}
>
  {isLive ? "Stop" : countdown > 0 ? `Going Live in ${countdown}s...` : "Go Live"}
</button>

                )}
              </div>
            </div>
            {/* //list */}

            <main className="p-6 ">
              {/* Products Cards */}
             <div className="mt-6">
  <h3 className="text-lg font-semibold mb-2">Live Selling Products</h3>
  <div className="grid grid-cols-2 gap-4 max-w-xl">
    {liveProducts.map((product) => (
      <div
        key={product.id}
        className="border-2 border-purple-600 rounded-md p-1 bg-white"
      >
        <div className="bg-[#eceef0] relative rounded-xl">
          <p className="absolute top-1 left-1 p-2 rounded-tl-3xl rounded-br-3xl bg-red-700 text-white text-xs font-semibold px-3 rounded">
            {product.offer ? `${product.offer}% Offer` : "No Offer"}
          </p>
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-48 object-contain"
          />
          <p className="bg-[#98911f] absolute right-0 bottom-1 text-white text-xs text-center rounded-xl px-2 py-[3px] my-1 mr-4">
            {product.countdown}
          </p>
        </div>
        <div className="p-2 space-y-2">
          <h4 className="text-[13px] font-bold">{product.name}</h4>
          <p className="text-[15px] font-bold text-[#095228]">
            <span className="text-xs font-semibold mr-3 line-through text-gray-400">
              ₹{product.originalPrice}
            </span>
            ₹{product.discountedPrice}
          </p>

          <p className="text-xs">
            Qty :{" "}
            <span className="text-red-600 font-bold">
              {product.qtySold} Sold
            </span>{" "}
            / Out of {product.qtyOutOf}
          </p>
          <div className="text-center">
           <button
  onClick={() => handleStopSelling(product.id)}
  className="bg-red-900 text-white rounded-xl text-xs mt-2 p-2"
>
  Stop Selling
</button>

          </div>
        </div>
      </div>
    ))}
  </div>
</div>


              {/* Product Table */}
              <section className="bg-white rounded-lg mt-10 shadow">
                <div className="flex justify-between items-center  px-8 py-4">
                  <h2 className="font-bold text-sm">Your Product</h2>
                  {/* <input
                    type="search"
                    placeholder="Search Products"
                    className="border border-gray-300 rounded px-2 py-1 text-sm"
                  /> */}
                  <div className="relative w-full max-w-[200px]">
                    <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" />
                    <input
                      type="search"
                      placeholder="Search Products"
                      className="w-full border border-gray-300 bg-gray-100 rounded-3xl py-2 pl-10 pr-4 text-sm focus:outline-none focus:ring-2 focus:ring-gray-400"
                    />
                  </div>
                </div>

                <table className=" text-xs border border-gray-300 rounded">
                  <thead>
                    <tr className="bg-gray-200">
                      <th className="py-2 px-1  text-left">PRODUCTS</th>
                      <th className="py-2 px-1  text-left">PRICE</th>
                      <th className="py-2 px-1  text-left">DISCOUNT</th>
                      <th className="py-2 px-1  text-left">DISCOUNT PRICE</th>
                      <th className="py-2 px-1  text-left">COUNTDOWN TIMER</th>
                      <th className="py-2 px-1  text-left">QTY</th>
                      <th className="py-2 px-1 text-center">START SELLING</th>
                    </tr>
                  </thead>
                <tbody>
  {products.length > 0 ? (
    products.map((product, index) => {
      // Handle state updates per row
      const handleDiscountChange = (e) => {
        const value = e.target.value;
        const updatedProducts = [...products];

        // update offer_percentage
        updatedProducts[index].offer_percentage = value;

        // calculate discount price
        const price = parseFloat(product.product_price) || 0;
        const discountPercent = parseFloat(value) || 0;
        const discountPrice = price - (price * discountPercent) / 100;

        // update discount_price
        updatedProducts[index].discount_price = discountPrice.toFixed(2);

        setProducts(updatedProducts);
      };

      return (
        <tr key={product.id} className="border-t border-gray-300 p-2">
          {/* PRODUCT IMAGE + NAME + QTY */}
          <td className="p-2 w-48 flex items-center gap-2">
            <img
              src={product?.product_media?.[0]?.url || "/image/default.png"}
              alt={product.product_name}
              className="w-12 h-12 object-contain"
            />
            <div className="text-[10px] font-bold">
              <p className="line-clamp-2">{product.product_name}</p>
              <small className="text-green-600">
                Available Qty {product.product_qty}
              </small>
            </div>
          </td>

          {/* PRICE */}
          <td className="p-1">₹{product.product_price}</td>

          {/* DISCOUNT (%) — editable */}
          <td className="p-1">
            <input
              type="number"
              value={product.offer_percentage || ""}
              onChange={handleDiscountChange}
              className="w-full border border-gray-300 rounded-md px-2 py-3 text-xs"
              placeholder="%"
              min="0"
              max="100"
            />
          </td>

          {/* DISCOUNT PRICE — auto calculated */}
          <td className="p-1">
            <input
              value={product.discount_price || ""}
              readOnly
              className="w-full border border-gray-300 rounded-md px-2 py-3 text-xs bg-gray-100"
              placeholder="Discount Price"
            />
          </td>

          {/* COUNTDOWN TIMER (optional / editable by seller) */}
          <td className="p-1">
            <input
              className="w-full border border-gray-300 rounded-md px-2 py-3 text-xs"
              placeholder="HH:MM"
            />
          </td>

          {/* QTY (readonly for now) */}
          <td className="p-1">
            <input
              value={product.product_qty}
              readOnly
              className="w-full border border-gray-300 rounded-md px-2 py-3 text-xs bg-gray-100"
            />
          </td>

          {/* START SELLING BUTTON */}
          <td className="p-1 text-center">
           <button
    onClick={() => handleStartSelling(product)}
    className="text-[18px] bg-green-800 text-white rounded-full px-4 w-full h-8 flex items-center justify-center font-bold"
  >
    +
  </button>
          </td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="7" className="text-center py-4 text-gray-500">
        No products found
      </td>
    </tr>
  )}
</tbody>


                </table>
              </section>
            </main>

            {/* <div className="mt-6 mx-4 bg-white rounded shadow">
              <h2 className="text-xl font-semibold mb-4 p-4">
                Your Product List
              </h2>
              <table className="w-full text-left ">
                <thead>
                  <tr className="border-b bg-[#E4E7E9]   ">
                    <th className="py-2 pl-4 ">Products</th>
                    <th className="py-2">Price</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {[1, 2].map((item, i) => (
                    <tr key={i} className="border-b">
                      <td className="py-4 pl-4  flex items-center gap-4">
                        <img
                          src={"/image/indidvilesell.png"}
                          alt="Product"
                          className="w-16 h-16 object-cover rounded"
                        />
                        <span>ADIDAS 4DFWD X PARLEY RUNNING SHOES</span>
                      </td>
                      <td className="pl-4 ">
                        {i === 0 ? (
                          <>
                            <span className="line-through text-gray-400 mr-2">
                              $99
                            </span>
                            <span className="text-[#475156] font-semibold">
                              $70
                            </span>
                          </>
                        ) : (
                          <span className="text-[#475156] font-semibold">
                            $70
                          </span>
                        )}
                      </td>
                      <td>
                        <button className=" bg-[#095228] text-white px-4 py-1 rounded-full">
                          Pin the Product
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div> */}
          </div>{" "}
          {/* comments  */}
          {/* <div className="w-[30%]">
            <div className="max-w-sm w-full mx-auto p-4 bg-white rounded-2xl shadow">
              <div className="space-y-4 max-h-[450px] overflow-y-auto pr-2">
                {comments.map((comment) => (
                  <div key={comment.id} className="flex gap-3 border-b-2 pb-2">
                    <img
                      src={comment.avatar}
                      alt={comment.name}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div>
                      <div className="flex items-center justify-between text-sm">
                        <span className="font-semibold">{comment.name}</span>
                        <span className="text-gray-400 ml-2">
                          {comment.time}
                        </span>
                      </div>
                      <p className="text-gray-600 text-sm mt-1">
                        {comment.message}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-4 flex items-center border border-gray-300 rounded-full px-3 py-2 bg-white">
                <input
                  type="text"
                  placeholder="Add a comment"
                  className="flex-grow outline-none text-sm placeholder-gray-500"
                />
                <button className="bg-gradient-to-l from-[#08AEEA] to-[#1DE78B]  text-white text-sm font-medium px-4 py-1 rounded-full hover:bg-cyan-600 transition ml-2">
                  Send
                </button>
              </div>
            </div>{" "}
          </div> */}
                 <div className="golive-chatbox bg-[#F9FAFB] p-4 mb-5 h-[650px] relative">
                   <div className="absolute top-0 right-0 w-full h-[50%] z-10 bg-gradient-to-t from-[#ffffff00] to-[#ffffff] pointer-events-none" />
       
                 <div className="h-full overflow-y-auto space-y-4 relative scrollbar-hidden">
        <div className="comments-section p-4">
        {comments.map((c) => (
         <div key={c.commentId} className="p-3 rounded-md relative group">
           <div className="flex">
             <img src={profileimg} className="w-9" alt="profile" />
             <div className="pl-2">
               <p className="font-semibold">{c.username || "Anonymous"}</p>
               <p className="text-[10px] text-gray-500">
                 {new Date(c.timestamp).toLocaleTimeString([], {
                   hour: "2-digit",
                   minute: "2-digit",
                 })}
               </p>
             </div>
           </div>
           <p className="text-[12px] break-words pt-2">{c.comment}</p>
           <hr className="mt-2 pt-[1px] bg-[#D9D9D9]" />
       
           {/* Show delete only if the comment belongs to current user */}
           {c.userId === users.id && (
             <button
               onClick={() => deleteComment(c.commentId)}
               className="absolute top-2 right-2 text-red-500 hover:text-red-700"
             >
               Delete
             </button>
           )}
         </div>
       ))}
       
       </div>
       
       
       </div>
       
                   {/* Add Comment Input */}
                   <div className="flex items-center mt-4 w-full absolute bottom-2 right-0">
                     <div className="relative flex w-full mx-2">
                       <input
                         type="text"
                         placeholder="Add a comment"
                          value={comment}
           onChange={(e) => setComment(e.target.value)}
                         className="flex-1 p-3 border border-gray-300 rounded-full focus:outline-none"
                       />
                       <button      onClick={postComment}
        className="bg-blue-500 text-white px-4 py-2 rounded-full go-to-live-CTA absolute right-1 top-1">
                         Send
                       </button>
                     </div>
                     {/* Show Like Button only when live */}
                     {isLive && (
                       <button className="bg-[#BE1F2E] text-white px-3 mx-2 py-3 rounded-full">
                         <img src={like} alt="Like" />
                       </button>
                     )}
                   </div>
                   {/* Footer */}
                   <div className="lg:hidden">
                     <div className="copy-rights pb-5 text-center text-sm text-[#095228]">
                       © 2025 Pipaan. All Rights Reserved
                     </div>
                   </div>
                 </div>
        </div>
      </main>
    </div>
  );
};

export default Seller;
